interface IUSAState {
  name: string;
  abbrevitaion: string;
}

export const RxProviderOptions: { id: string; name: string }[] = [
  {
    name: 'Pear Connect',
    id: '1',
  },
]; // we are hard-coding this as Pear Connect, because the RxProvider is set on the backend in weaver-api

export const usaStates: IUSAState[] = [
  {
    name: 'Alabama',
    abbrevitaion: 'AL',
  },
  {
    name: 'Alaska',
    abbrevitaion: 'AK',
  },
  {
    name: 'American Samoa',
    abbrevitaion: 'AS',
  },
  {
    name: 'Arizona',
    abbrevitaion: 'AZ',
  },
  {
    name: 'Arkansas',
    abbrevitaion: 'AR',
  },
  {
    name: 'California',
    abbrevitaion: 'CA',
  },
  {
    name: 'Colorado',
    abbrevitaion: 'CO',
  },
  {
    name: 'Connecticut',
    abbrevitaion: 'CT',
  },
  {
    name: 'Delaware',
    abbrevitaion: 'DE',
  },
  {
    name: 'District of Columbia',
    abbrevitaion: 'DC',
  },
  {
    name: 'Federated States of Micronesia',
    abbrevitaion: 'FM',
  },
  {
    name: 'Florida',
    abbrevitaion: 'FL',
  },
  {
    name: 'Georgia',
    abbrevitaion: 'GA',
  },
  {
    name: 'Guam',
    abbrevitaion: 'GU',
  },
  {
    name: 'Hawaii',
    abbrevitaion: 'HI',
  },
  {
    name: 'Idaho',
    abbrevitaion: 'ID',
  },
  {
    name: 'Illinois',
    abbrevitaion: 'IL',
  },
  {
    name: 'Indiana',
    abbrevitaion: 'IN',
  },
  {
    name: 'Iowa',
    abbrevitaion: 'IA',
  },
  {
    name: 'Kansas',
    abbrevitaion: 'KS',
  },
  {
    name: 'Kentucky',
    abbrevitaion: 'KY',
  },
  {
    name: 'Louisiana',
    abbrevitaion: 'LA',
  },
  {
    name: 'Maine',
    abbrevitaion: 'ME',
  },
  {
    name: 'Marshall Islands',
    abbrevitaion: 'MH',
  },
  {
    name: 'Maryland',
    abbrevitaion: 'MD',
  },
  {
    name: 'Massachusetts',
    abbrevitaion: 'MA',
  },
  {
    name: 'Michigan',
    abbrevitaion: 'MI',
  },
  {
    name: 'Minnesota',
    abbrevitaion: 'MN',
  },
  {
    name: 'Mississippi',
    abbrevitaion: 'MS',
  },
  {
    name: 'Missouri',
    abbrevitaion: 'MO',
  },
  {
    name: 'Montana',
    abbrevitaion: 'MT',
  },
  {
    name: 'Nebraska',
    abbrevitaion: 'NE',
  },
  {
    name: 'Nevada',
    abbrevitaion: 'NV',
  },
  {
    name: 'New Hampshire',
    abbrevitaion: 'NH',
  },
  {
    name: 'New Jersey',
    abbrevitaion: 'NJ',
  },
  {
    name: 'New Mexico',
    abbrevitaion: 'NM',
  },
  {
    name: 'New York',
    abbrevitaion: 'NY',
  },
  {
    name: 'North Carolina',
    abbrevitaion: 'NC',
  },
  {
    name: 'North Dakota',
    abbrevitaion: 'ND',
  },
  {
    name: 'Northern Mariana Islands',
    abbrevitaion: 'MP',
  },
  {
    name: 'Ohio',
    abbrevitaion: 'OH',
  },
  {
    name: 'Oklahoma',
    abbrevitaion: 'OK',
  },
  {
    name: 'Oregon',
    abbrevitaion: 'OR',
  },
  {
    name: 'Palau',
    abbrevitaion: 'PW',
  },
  {
    name: 'Pennsylvania',
    abbrevitaion: 'PA',
  },
  {
    name: 'Puerto Rico',
    abbrevitaion: 'PR',
  },
  {
    name: 'Rhode Island',
    abbrevitaion: 'RI',
  },
  {
    name: 'South Carolina',
    abbrevitaion: 'SC',
  },
  {
    name: 'South Dakota',
    abbrevitaion: 'SD',
  },
  {
    name: 'Tennessee',
    abbrevitaion: 'TN',
  },
  {
    name: 'Texas',
    abbrevitaion: 'TX',
  },
  {
    name: 'Utah',
    abbrevitaion: 'UT',
  },
  {
    name: 'Vermont',
    abbrevitaion: 'VT',
  },
  {
    name: 'Virgin Islands',
    abbrevitaion: 'VI',
  },
  {
    name: 'Virginia',
    abbrevitaion: 'VA',
  },
  {
    name: 'Washington',
    abbrevitaion: 'WA',
  },
  {
    name: 'West Virginia',
    abbrevitaion: 'WV',
  },
  {
    name: 'Wisconsin',
    abbrevitaion: 'WI',
  },
  {
    name: 'Wyoming',
    abbrevitaion: 'WY',
  },
];
